"use client";

import { useEffect } from "react";
import { captureFirstTouchFromLocation } from "@/hooks/use-lead-attribution";
import { isEmbedDocument } from "@/lib/embed/is-embed-document";

export function AttributionCapture(): null {
  useEffect(() => {
    if (isEmbedDocument(window.location.pathname)) return;
    captureFirstTouchFromLocation();
  }, []);
  return null;
}
